import React from 'react';
import { Clickable } from '@moda/om';
import FavoriteFilledLargeIcon from '@moda/icons/favorite-filled-24';
import FavoriteOutlineLargeIcon from '@moda/icons/favorite-outline-24';
import classNames from 'classnames';
import { useFavorite } from '../useFavorite';
import { UseFavoritesProps } from '../useFavorites';
import { FavoriteConfirmRemove } from '../FavoriteConfirmRemove';

import './FavoriteIcon.scss';

export interface FavoriteIconProps extends UseFavoritesProps {
  className?: string;
}

export const FavoriteIcon: React.FC<FavoriteIconProps> = ({ variant, className }) => {
  const { label, onClick, isFavorited, showConfirmRemove, onCloseConfirm } = useFavorite({
    variant
  });

  return (
    <>
      <Clickable
        aria-label={label}
        className={classNames('FavoriteIcon', className)}
        data-testid="favorite-icon"
        onClick={(event: Event | React.MouseEvent) => {
          onClick();
          event.stopPropagation();
        }}
      >
        {isFavorited ? <FavoriteFilledLargeIcon /> : <FavoriteOutlineLargeIcon />}
      </Clickable>

      {showConfirmRemove && <FavoriteConfirmRemove onConfirm={onClick} onClose={onCloseConfirm} />}
    </>
  );
};
